import { ConfirmService } from './../../../../../core/components/confirm/confirm.service';
import { Component, OnInit, ViewChild, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material';
import { KpiDialogComponent } from './kpi-dialog.component';
import { KPI } from '../../../../../core/modelos/kpi';

import { KpisService } from './kpis.service';
import { Router, NavigationEnd } from '@angular/router';
import { NotificacionesService } from '../../../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-kpis-tabla',
    templateUrl: './kpis-tabla.component.html',
    styleUrls: ['./kpis-tabla.component.scss']
})
export class KpisTablaComponent implements OnInit, AfterViewInit {

    // Tabla KPIS
    displayedColumns = [];
    dataSource: MatTableDataSource<KPI>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() kpis: KPI[];
    @Input() activoId: number;
    @Input() esAdminBod: boolean;

    @Output() cambioKpis = new EventEmitter<boolean>();

    kpiDialogRef: MatDialogRef<KpiDialogComponent>;

    constructor(
        private dialog: MatDialog,
        private kpisService: KpisService,
        private router: Router,
        private confirmService: ConfirmService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                // trick the Router into believing it's last link wasn't previously loaded
                this.router.navigated = false;
                // if you need to scroll back to top, here is the right place
                window.scrollTo(0, 0);
            }
        });
    }

    ngOnInit() {
        if (this.esAdminBod) {
            this.displayedColumns = ['id', 'descripcion', 'valor', 'acciones'];
        } else {
            this.displayedColumns = ['descripcion', 'valor', 'acciones'];
        }
    }

    ngAfterViewInit() {

        setTimeout(() => {

            this.dataSource = new MatTableDataSource(this.kpis);

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            // Traduzco etiqueta si es español
            if (this.translate.currentLang === 'es') {
                this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
            }

        }, 0);

    }

    openKpiDialog(kpi?: KPI) {

        const indice = this.kpis.indexOf(kpi);

        this.kpiDialogRef = this.dialog.open(KpiDialogComponent, {
            data: {
                id: indice !== -1 ? kpi.id : '',
                descripcion: indice !== -1 ? kpi.descripcion : '',
                valor: indice !== -1 ? kpi.valor : '',
                clave: indice !== -1 ? kpi.clave : 100,
                activo_id: this.activoId
            }
        });

    }

    deleteKpi(kpi?: KPI) {

        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Activos.Kpis.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Activos.Kpis.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.kpisService.deleteKpi(kpi.id).subscribe(
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Kpis.KpiBorrado);
                                    this.router.navigate(['/activos/editar', this.activoId]);
                                } else {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Kpis.KpiNOBorrado);
                                }
                            },
                            err => {
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );


    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/components/kpis-tabla/kpis-tabla.component.ts